export interface NavLinkItem {
  label: string
  to: string
}

export const navLinks: NavLinkItem[] = [
  { label: 'Home', to: '/' },
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'Who It Is For', to: '/who-its-for' },
  { label: 'About', to: '/about' },
]
